import { NavLink, Outlet, useLocation, Navigate } from "react-router-dom";
import "./ServicesPage.css";

const sidebarLinks = [
      { label: "AI Strategy & Advisory",           path: "/approach/ai-strategy" },
      { label: "Digital Transformation Advisory",  path: "/approach/digital-transformation" },
      { label: "Data Strategy Advisory",           path: "/approach/data-strategy" },
      { label: "IT Operations Advisory",           path: "/approach/it-operations" },
      { label: "GCC Advisory",                     path: "/approach/gcc-advisory" },
    ];

export default function ServicesPage() {
  const location = useLocation();
  const isRoot =
    location.pathname === "/approach" || location.pathname === "/approach/";

  return (
    <div className="about-layout">
      {/* ── Sidebar ── */}
      <aside className="about-sidebar">
        <p className="about-sidebar__heading">Services</p>
        <nav className="about-sidebar__nav">
          {sidebarLinks.map((link) => (
            <NavLink
              key={link.path}
              to={link.path}
              className={({ isActive }) =>
                isActive
                  ? "about-sidebar__link about-sidebar__link--active"
                  : "about-sidebar__link"
              }
            >
              <span className="about-sidebar__dot" />
              {link.label}
            </NavLink>
          ))}
        </nav>
      </aside>

      {/* ── Main content ── */}
      <main className="about-main">
        {isRoot ? <Navigate to="/about/vision" replace /> : <Outlet />}
      </main>
    </div>
  );
}